// import React from "react";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import axios from 'axios';
import swal from '@sweetalert/with-react';
import LogoWhite from '../../assets/img/logo-white-small.png';
import { getApiHeader, removeUserSession } from '../../utils/CommonFunctions';

// function Navigation(props) {

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class PostPaidNavigation extends Component {


    constructor(props) {

        super(props);

        this.state = { 
            selected_number: null ,
            is_prepaid:sessionStorage.getItem('is_prepaid'),
            nbn_activation:"",
            is_wme_customer:0,
            is_wme_prepaid:0
         }

    }

    handleLogout = async () => {

        let p = new Promise(async (resolve, reject) => {

            let headers = await getApiHeader();
            let res = await axios.get(`${SERVER_URL}logout`, { headers });
            let data = res.data.data;
            console.log(data);

            removeUserSession();
            resolve();

        });

        p.then(
            () => {

                this.props.history.push("/login");

            },
            () => {
                alert("Error in logout");
            }
        )

    }

  
    
    checkIsNbnCustomer = async () => {
		let headers = await getApiHeader();
		let res = await axios.get(`${SERVER_URL}nbn/check_is_nbn`, { headers }).then(response => {
			  let data = response.data;
			  sessionStorage.setItem('is_nbn',data.data.is_nbn_customer)
			  sessionStorage.setItem('nbn_activation_status',data.data.nbn_activation_status)
			   const activation=sessionStorage.getItem('nbn_activation_status')
		      this.setState({ button: data.data.is_nbn_customer })
		}).catch(error => {
			this.setState({ loading: false });
			if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {
				swal({
					text: error.response.data.message,
					allowOutsideClick: false,
					closeOnClickOutside: false,
					icon: "warning"
				}).then(() => {
					this.handleLogout();
				});
			}
			else {
				swal("Internal Server Error", "", "warning");
			}
		});
	}



    componentDidMount() {
        this.checkIsNbnCustomer()
        const activation = sessionStorage.getItem('nbn_activation_status');
        const wmeCustomer = sessionStorage.getItem('is_wme_customer');
        const wmePrepaid = sessionStorage.getItem('is_wme_prepaid');

        this.setState({
            is_wme_customer: wmeCustomer === "1" ? 1 : 0,
            is_wme_prepaid: wmePrepaid === "1" ? 1 : 0,
        });

        this.setState({
            nbn_activation: activation
        });
    }

  
    componentDidUpdate(prevProps, prevState) {
        // Only update state if the activation status has changed
        const activation = sessionStorage.getItem('nbn_activation_status');
        if (prevState.nbn_activation !== activation) {
            this.setState({
                nbn_activation: activation
            });
        }
        console.log("activation number",activation)

    }





    menuClick = () => {
        document.getElementById("kt_aside_close_btn").click();

    }

    render() {
        return (
            <>
                <button className="kt-aside-close " id="kt_aside_close_btn"><i className="la la-close"></i></button>
                <div className="kt-aside  kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop" id="kt_aside">
                    <div className="kt-aside__brand kt-grid__item " id="kt_aside_brand">
                        <div className="kt-aside__brand-logo">
                            <Link to="/service-list">
                                <img alt="Telsim" height="40" src={LogoWhite} />
                            </Link>
                        </div>
                        <div className="kt-aside__brand-tools">
                            <button className="kt-aside__brand-aside-toggler kt-aside__brand-aside-toggler--left" id="kt_aside_toggler"><span></span></button>
                        </div>
                    </div>
                    <div className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper">
                        <div id="kt_aside_menu" className="kt-aside-menu " data-ktmenu-vertical="1" data-ktmenu-scroll="1" data-ktmenu-dropdown-timeout="500">
                            <ul className="kt-menu__nav " >
                                <li className={`kt-menu__item  ${((this.props.location.pathname === "/my-service-list") || (this.props.location.pathname === "/my-service-list")) ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                    <Link onClick={this.menuClick} to="/my-service-list" className="kt-menu__link  active"><i className="kt-menu__link-icon flaticon2-graphic"></i><span className="kt-menu__link-text">My Services</span></Link>
                                </li>
                                <li className={`kt-menu__item  ${this.props.location.pathname === "/account-summary" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                    <Link onClick={this.menuClick} to="/account-summary" className="kt-menu__link "><i className="kt-menu__link-icon flaticon2-architecture-and-city"></i><span className="kt-menu__link-text">Account summary</span></Link>
                                </li>
                                <li className={`kt-menu__item  ${this.props.location.pathname === "/my-profile" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                    <Link onClick={this.menuClick} to="/my-profile" className="kt-menu__link "><i className="kt-menu__link-icon flaticon-avatar"></i><span className="kt-menu__link-text">My Profile </span></Link>
                                </li>
                                <li className={`kt-menu__item  ${ this.props.location.pathname === "/my-payments" ? "kt-menu__item--active" : ""  }`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
									<Link onClick={this.menuClick} to="/my-payments" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-credit-card"></i><span className="kt-menu__link-text">My Payments</span></Link>
								</li>

                                <li className={`kt-menu__item  ${ this.props.location.pathname === "/add_a_mobile_plan" ? "kt-menu__item--active" : ""  }`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
									<Link onClick={this.menuClick} to="/add_a_mobile_plan" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-credit-card"></i><span className="kt-menu__link-text">Add a Mobile Plan</span></Link>
								</li>

                               

                                {this.state.is_wme_customer === 1 && this.state.is_wme_prepaid === 1 && (
                                    <>
                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/RechargeHome" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/RechargeHome" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-bolt "></i><span className="kt-menu__link-text">Recharge</span></Link>
                                        </li>
                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/RechargeAFriend" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/RechargeAFriend" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-bolt "></i><span className="kt-menu__link-text">Recharge a Friend</span></Link>
                                        </li>
                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/data-gifting" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/data-gifting" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-gift "></i><span className="kt-menu__link-text">Data Gifting</span></Link>
                                        </li>
                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/ReferAbuddy" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/ReferAbuddy" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-location-arrow"></i><span className="kt-menu__link-text">Refer A Buddy</span></Link>
                                        </li>
                                         <li className={`kt-menu__item  ${this.props.location.pathname === "/sim-only-migration" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/sim-only-migration" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-location-arrow"></i><span className="kt-menu__link-text">Upgrade to Sim Only</span></Link>
                                        </li>
                                    </>
                                )}




                                {this.state.is_wme_prepaid === 0 && (
                                    <>

                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/change-plan" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/change-plan" className="kt-menu__link "><i className="kt-menu__link-icon flaticon2-calendar-8  "></i><span className="kt-menu__link-text">Change Plan  </span></Link>
                                        </li>
                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/add-packs" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/add-packs" className="kt-menu__link "><i className="kt-menu__link-icon flaticon2-calendar-8  "></i><span className="kt-menu__link-text">Add Packs  </span></Link>
                                        </li>

                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/data-gifting" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/data-gifting" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-gift  "></i><span className="kt-menu__link-text">Data Gifting  </span></Link>
                                        </li>
                                        <li className={`kt-menu__item  ${this.props.location.pathname === "/sim-services" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                            <Link onClick={this.menuClick} to="/sim-services" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-mobile"></i><span className="kt-menu__link-text">Cancel Service </span></Link>
                                        </li>
                                        
                                    </>
                                )}                                              

                                  
                                 {this.state.nbn_activation=="1" && 
                                 <></>
                               
                                      }
                                      {/* {this.state.is_prepaid === '0' &&
                                  <li className={`kt-menu__item  ${this.props.location.pathname === "/activatev3" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                    <Link onClick={this.menuClick} to="/activatev3" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-group"></i><span className="kt-menu__link-text">Activate Prepaid Mobile Plan </span></Link>
                                </li> } */}
                              
                                {this.state.is_prepaid === '0' &&
                                <>
                                </>
                               
                                }
                                {/* <li className={`kt-menu__item  ${this.props.location.pathname === "/MyProfile" ? "kt-menu__item--active" : ""}`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                    <Link onClick={this.menuClick} to="" className="kt-menu__link "><i className="kt-menu__link-icon flaticon-avatar"></i><span className="kt-menu__link-text">Modify Services  </span></Link>
                                </li> */}

                               {
										(this.state.button === 1 || this.props.location.pathname =='/connection')?
										null
                                        :
										<li className={`kt-menu__item  ${ this.props.location.pathname === "/AddNbn" ? "kt-menu__item--active" : ""  }`} aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                    <Link onClick={this.menuClick} to="/Add_Nbn" className="kt-menu__link "><i className="kt-menu__link-icon fa fa-location-arrow"></i><span className="kt-menu__link-text">Purchase NBN Service</span></Link>
                                </li>}


                            </ul>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(PostPaidNavigation);
